import React from "react";

import classNames from "classnames";
import { get, useFormContext } from "react-hook-form";

import DatePicker from "./DatePicker";

import type { JSX } from "react";

interface DateRangePickerProps {
  name: string;
  startLabel: string;
  endLabel: string;
  isCompact?: boolean;
  className?: string;
  minDate?: Date;
  maxDate?: Date;
  portalId?: string;
  isRequired?: boolean;
}

function DateRangePicker({
  name,
  startLabel,
  endLabel,
  isCompact,
  className,
  minDate,
  maxDate,
  portalId,
  isRequired,
}: DateRangePickerProps): JSX.Element {
  const { watch } = useFormContext();

  const formValues = watch();

  const startFieldName = `${name}.startDate`;
  const endFieldName = `${name}.endDate`;

  const startDate = get(formValues, startFieldName);
  const endDate = get(formValues, endFieldName);

  const containerClassNames = classNames("mb-[1.875rem]", className);

  return (
    <div className={containerClassNames}>
      <DatePicker
        className="!mb-0"
        isCompact={isCompact}
        isRequired={isRequired}
        label={startLabel}
        maxDate={endDate ?? maxDate}
        minDate={minDate}
        name={startFieldName}
        portalId={portalId}
      />
      <DatePicker
        className="!mb-0"
        isCompact={isCompact}
        isRequired={isRequired}
        label={endLabel}
        maxDate={maxDate}
        minDate={startDate ?? minDate}
        name={endFieldName}
        portalId={portalId}
      />
    </div>
  );
}

export default DateRangePicker;
